export const reactQuillFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'script', 'color', 'background',
    'list', 'align',
    'blockquote', 'code-block',
    'link'
]

export const reactQuillModules = {
    toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        [{ 'color': [] }, { 'background': [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['blockquote', 'code-block'],
        ['link'],
    ],
}